import { render, staticRenderFns } from "./NotAccess.vue?vue&type=template&id=67ee02b1&scoped=true"
import script from "./NotAccess.vue?vue&type=script&lang=js"
export * from "./NotAccess.vue?vue&type=script&lang=js"
import style0 from "./NotAccess.vue?vue&type=style&index=0&id=67ee02b1&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ee02b1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('67ee02b1')) {
      api.createRecord('67ee02b1', component.options)
    } else {
      api.reload('67ee02b1', component.options)
    }
    module.hot.accept("./NotAccess.vue?vue&type=template&id=67ee02b1&scoped=true", function () {
      api.rerender('67ee02b1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/NotAccess.vue"
export default component.exports